import {
    Heading,
    Box,
    Center,
    Text,
    useColorModeValue,
} from '@chakra-ui/react';

export default function Card1({ user }) {
    return (
        <Center py={6} display='inline-block' m={6}>
            <Box
                // maxW={'300px'}
                w={'300px'}
                // h={'280px'}
                bg={useColorModeValue('white', 'gray.900')}
                boxShadow={'lg'}
                border={'1px solid #e2e8f0'}
                rounded={'lg'}
                py={2}
                px={2}
                m={6}
                textAlign={'center'}
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}
            >
                <Heading fontSize={'2xl'} fontFamily={'body'}>
                    {user.name}
                </Heading>
                <Text fontWeight={600} color={'gray.500'} mb={4}>
                    {user.contact}
                </Text>
                <Text
                    textAlign={'center'}
                    color={useColorModeValue('gray.700', 'gray.400')}
                    px={3}>
                    {user.course}
                </Text>




            </Box>
        </Center>
    );
}